import { $fetch } from 'utils/fetch'

export async function endActiveCall(callId) {
  try {
    const { data } = await $fetch(
      `/v1/calls/${callId}/stop`,
      {
        method: 'POST',
        body: { call_id: callId },
      },
    )

    return { is_call_ended: true, data }
  }
  catch (error) {
    console.error('Error ending call in endActiveCall():', error)
    return { is_call_ended: false, error: error.message }
  }
}
